import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { PermissionGuard } from './core/guards/permission.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./modules/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadComponent: () => import('./layouts/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./modules/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'DASHBOARD' }
      },
      {
        path: 'products',
        loadComponent: () => import('./modules/products/products.component').then(m => m.ProductsComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'PRODUCTS' }
      },
      {
        path: 'orders',
        loadComponent: () => import('./modules/orders/orders.component').then(m => m.OrdersComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'ORDERS' }
      },
      {
        path: 'customers',
        loadComponent: () => import('./modules/customers/customers.component').then(m => m.CustomersComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'CUSTOMERS' }
      },
      {
        path: 'collections',
        loadComponent: () => import('./modules/collections/collections.component').then(m => m.CollectionsComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'COLLECTIONS' }
      },
      {
        path: 'gift-cards',
        loadComponent: () => import('./modules/gift-cards/gift-cards.component').then(m => m.GiftCardsComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'GIFT_CARD' }
      },
      {
        path: 'scheduler',
        loadComponent: () => import('./modules/scheduler/scheduler.component').then(m => m.SchedulerComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'SCHEDULER' }
      },
      {
        path: 'users',
        loadComponent: () => import('./modules/users/users.component').then(m => m.UsersComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'USER_MANAGEMENT' }
      },
      {
        path: 'documentation',
        loadComponent: () => import('./modules/documentation/documentation.component').then(m => m.DocumentationComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'DOCUMENTATION' }
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
